import { defineStore } from "pinia";
import { ref } from "vue";
import { Lang } from "@/types/blogs";

export const useLangStore = defineStore("lang", () => {
  const current = ref<Lang>("ru");
  const fallbackLang: Lang = "en";

  function setLang(lang: Lang) {
    current.value = lang;
    localStorage.setItem("lang", lang);
  }

  function initLang() {
    const saved = localStorage.getItem("lang") as Lang | null;
    if (saved) {
      current.value = saved;
    } else {
      current.value = "ru";
    }
  }

  return { current, fallbackLang, setLang, initLang };
});
